export const Industries = [
  // { name: 'administrative', parsedName: 'Administrative' },
  // { name: 'business', parsedName: 'Business' },
  // { name: 'customer-service', parsedName: 'Customer Service' },
  // { name: 'finance', parsedName: 'Finance' },
  // { name: 'leadership', parsedName: 'Leadership' },

  {
    name: 'automobiles-and-components',
    parsedName: 'Automobiles And Components',
  },
  { name: 'banks', parsedName: 'Banks' },
  { name: 'capital-goods', parsedName: 'Capital Goods' },
  {
    name: 'commercial-and-professional-services',
    parsedName: 'Commercial And Professional Services',
  },
  {
    name: 'consumer-durables-and-apparel',
    parsedName: 'Consumer Durables And Apparel',
  },
  { name: 'consumer-services', parsedName: 'Consumer Services' },
  { name: 'diversified-financials', parsedName: 'Diversified Financials' },
  { name: 'energy', parsedName: 'Energy' },
  {
    name: 'food-beverage-and-tobacco',
    parsedName: 'Food Beverage And Tobacco',
  },
  {
    name: 'food-and-staples-retailing',
    parsedName: 'Food And Staples Retailing',
  },
  {
    name: 'health-care-equipment-and-services',
    parsedName: 'Health Care Equipment And Services',
  },
  {
    name: 'household-and-personal-products',
    parsedName: 'Household And Personal Products',
  },
  { name: 'insurance', parsedName: 'Insurance' },
  { name: 'materials', parsedName: 'Materials' },
  { name: 'media-and-entertainment', parsedName: 'Media And Entertainment' },
  {
    name: 'pharmaceuticals-biotechnology-and-life-sciences',
    parsedName: 'Pharmaceuticals Biotechnology And Life Sciences',
  },
  { name: 'real-estate', parsedName: 'Real Estate' },
  { name: 'retailing', parsedName: 'Retailing' },
  {
    name: 'semiconductors-and-semiconductor-equipment',
    parsedName: 'Semiconductors And Semiconductor Equipment',
  },
  { name: 'software-and-services', parsedName: 'Software And Services' },
  {
    name: 'technology-hardware-and-equipment',
    parsedName: 'Technology Hardware And Equipment',
  },
  {
    name: 'telecommunication-services',
    parsedName: 'Telecommunication Services',
  },
  { name: 'transportation', parsedName: 'Transportation' },
  { name: 'utilities', parsedName: 'Utilities' },
];
